import { render } from "./CallToAction.vue?vue&type=template&id=05763634"
import script from "./CallToAction.vue?vue&type=script&lang=js"
export * from "./CallToAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Misc/CallToAction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05763634"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05763634', __exports__)) {
    api.reload('05763634', __exports__)
  }
  
  module.hot.accept("./CallToAction.vue?vue&type=template&id=05763634", () => {
    api.rerender('05763634', render)
  })

}


export default __exports__